<script>
  export let imagePath;
  export let clickFunc = () =>
    console.log("ピクトグラムボタンのコンポネントです。");
</script>

<style>
  .btn-img {
    background-color: white;
    width: 75px;
    height: 75px;
  }
</style>

{#if imagePath.indexOf('-A.png') != -1}
  <img
    id="clickable_pict_btn"
    class="m-4 btn-img"
    src={imagePath}
    on:click={clickFunc}
    alt="pict" />
{:else}<img class="m-4 btn-img" src={imagePath} alt="pict" />{/if}
